import { BlocksTableBody } from 'blocks-nextjs/blocks-web-components/components/table-body/table-body';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';

export const CatTableBody = createComponent({ react: React, tagName: 'cat-table-body', elementClass: BlocksTableBody });
